import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruthruns2postPostScreenTruthRunsIdCancelResponseSchema = jsonObject
export type tcpscreentruthruns2postPostScreenTruthRunsIdCancelResponse = z.infer<typeof tcpscreentruthruns2postPostScreenTruthRunsIdCancelResponseSchema>
